export class ListApplicationOverrideResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "applicationOverrides",
            "baseName": "applicationOverrides",
            "type": "Array<ApplicationOverride>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListApplicationOverrideResponse.attributeTypeMap;
    }
    constructor() {
    }
}
